import { createContext, useContext } from "react";

export interface EditableEdgeContextValue {
  isEdit: boolean;
  onDeleteEdge: (edgeId: string) => void;
}

const EditableEdgeContext = createContext<EditableEdgeContextValue>({
  isEdit: false,
  onDeleteEdge: () => {},
});

export const EditableEdgeProvider = EditableEdgeContext.Provider;

export function useEditableEdge(): EditableEdgeContextValue {
  return useContext(EditableEdgeContext);
}
